import { createLink, interpolateString } from '@utils/string';
import { ChartExportType, IUsageMetricConst, IUsageMetrics } from '@redux/types/types';
import { DOCS_URL } from './constant';

export const METERING_PAGE_HEADER = 'Usage';
export const NO_LIMIT_LABEL = 'Unlimited';
export const PIPELINE_USAGE_CYCLE_HEADER = 'Total pipelines and indexes in your organization';
export const CREDITS = 'Credits';

export const PIPELINES_TABLE_COLUMNS_TITLE = {
  NAME: 'Name',
  TYPE: 'Type',
  CREDITS: 'Credits used',
  STORAGE_UNITS: 'Document Storage Units',
  WORKSPACE_NAME: 'Workspace',
  DOCUMENTS: 'Documents',
};

export const ORGANIZATION_PLAN_INFO = {
  label: 'Your organization',
  limitLabel: 'Usage cycle (%usageCycle%)',
  targetLabel: `%days% Days left`,
};

export const PIPELINE_USAGE_DOCS_URL = `${DOCS_URL}docs/understand-pipeline-usage`;

export const USAGE_METRIC_MAP: Record<keyof IUsageMetrics, IUsageMetricConst> = {
  document_storage_units: {
    label: 'Document Storage Units',
    tooltip: interpolateString(
      "Storage units measure how much vector storage you're using. They depend on how many chunks your documents are split into and the size of your embedding model. For more information, see %link%.",
      {
        link: createLink(PIPELINE_USAGE_DOCS_URL, 'documentation'),
      },
    ),
    limitLabel: 'Cycle limit',
  },
  credits: {
    label: 'Credits',
    tooltip: interpolateString(
      'Credits count the hours your pipelines were deployed and your indexes processed files during this usage cycle. One credit equals one hour of deployed pipeline time or one hour of indexing. For details, see %link%.',
      {
        link: createLink(PIPELINE_USAGE_DOCS_URL, 'documentation'),
      },
    ),
    limitLabel: 'Plan limit',
  },
};

export const USAGE_METRICS_ORDERED_KEYS: (keyof IUsageMetrics)[] = [
  'credits',
  'document_storage_units',
];

export const EXPORT_CHART_OPTIONS = [
  {
    label: 'Export as PNG',
    key: ChartExportType.PNG,
  },
  {
    label: 'Export as JPEG',
    key: ChartExportType.JPEG,
  },
  {
    label: 'Export as PDF',
    key: ChartExportType.PDF,
  },
];

// Filtering pipeline usage metrics

export const PIPELINE_USAGE_METRICS_FILTERS_TYPE_LABEL = 'Type';
export const PIPELINE_USAGE_METRICS_FILTERS_FIELD_KEYS = {
  TYPE: 'pipeline_type',
};
export const PIPELINE_USAGE_METRICS_TYPE_FILTERS_LABELS = {
  INDEX: 'Index',
  PIPELINE: 'Pipeline',
};

// Sorting pipeline usage metrics

export const DEFAULT_SORTING_KEY = 'pipelines_used_desc';
export const PIPELINE_USAGE_METRICS_SORTING_OPTIONS = [
  { key: 'pipelines_used_asc', label: 'Credits ascending' },
  { key: 'pipelines_used_desc', label: 'Credits descending' },
  { key: 'document_storage_units_asc', label: 'Storage units ascending' },
  { key: 'document_storage_units_desc', label: 'Storage units descending' },
];
export const SORTING_PARAMS_BY_KEY = {
  pipelines_used_asc: {
    field: 'pipelines_used',
    order: 'ASC',
  },
  pipelines_used_desc: {
    field: 'pipelines_used',
    order: 'DESC',
  },
  document_storage_units_asc: {
    field: 'document_storage_units',
    order: 'ASC',
  },
  document_storage_units_desc: {
    field: 'document_storage_units',
    order: 'DESC',
  },
};

export const UPGRADE_PAGE_SECTION = {
  TITLE: 'Usage',
  DESCRIPTION: [
    {
      paragraph:
        'Track your organization’s usage at a glance. View total pipeline hours, monitor storage usage, and check the pipelines running in the current cycle. Keep an eye on your usage to manage resources efficiently.',
    },
    {
      paragraph: 'For more details, see the %documentationLink%.',
    },
  ],
};
